import { Injectable } from '@angular/core';
import { UserInvitationRecord } from '@models/organisations/user-invitation-record';
import BaseApiService from "@shared/services/base/base-api.service";
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserInvitationsApiService extends BaseApiService {
  getUserInvitations(): Observable<UserInvitationRecord[]> {
    return this.api.get<UserInvitationRecord[]>(`${ environment.api_url }/invites`)
      .pipe(map(u => u.map(u => new UserInvitationRecord(u))));
  }

  deleteInvitation(invitationId: string): Observable<void> {
    return this.api.delete<void>(`${ environment.api_url }/invites/${ invitationId }`);
  }
}
